import React, { useEffect, useState } from "react";
import { Formik, useFormikContext } from "formik";
import * as Yup from "yup";
import toast from "react-hot-toast";
import PersonSearchIcon from "@mui/icons-material/PersonSearch";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import CustomFilterInput from "../../shared/CustomFilterInput";
import AppButton from "../../shared/AppButton";

function AutoSubmit() {
  const { values, submitForm } = useFormikContext();
  useEffect(() => {
    if (values.nationalId && values.nationalId.length === 10) {
      if (!values?.patientName) {
        toast.error("Please Enter Patient Name");
        return;
      }
      submitForm();
    }
  }, [values.nationalId, submitForm, values?.patientName]);

  return null;
}

function AramcoChhiForm({
  setChiReqRecord,
  setSystemType,
  eligibilityId,
  setEligibilityId,
  setPatientName,
}) {
  const { t } = useTranslation();
  const [chiLoading, setChiLoading] = useState(false);
  const navigate = useNavigate();

  const systemTypes = [
    { id: 1, name: t("Nationals And Residents") },
    { id: 2, name: t("Visitors") },
    { id: 3, name: t("Tourists") },
    { id: 4, name: t("Premium Residents") },
    { id: 5, name: t("Hajj & Umrah Visitors") },
  ];

  const validationSchema = Yup.object().shape({
    systemType: Yup.number().required(t("System Type is required")),
    nationalId: Yup.string().required(t("National Id is required")),
    patientName: Yup.string().required(t("Patient Name is required")),
  });

  const addData = async (values) => {
    setChiLoading(true);
    setSystemType(values.systemType);
    try {
      setEligibilityId(null);
      setChiReqRecord(values?.nationalId);
      setPatientName(values?.patientName);
    } catch (error) {
      console.log(error);
    } finally {
      setChiLoading(false);
    }
  };

  return (
    <Formik
      initialValues={{
        systemType: 1,
        nationalId: "",
        patientName: "",
      }}
      enableReinitialize={true}
      validationSchema={validationSchema}
      onSubmit={(values) => {
        addData(values);
      }}
    >
      {({
        values,
        errors,
        touched,
        handleChange,
        handleBlur,
        handleSubmit,
      }) => (
        <div className="bg-white border border-slate-200 rounded-lg p-2 mb-2">
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 xl:grid-cols-4 gap-x-1.5 gap-y-1.5">
            <div>
              <CustomFilterInput
                label={t("System Type")}
                name="systemType"
                isSelect
                value={values.systemType}
                onChange={handleChange}
                onBlur={handleBlur}
                options={systemTypes}
                error={errors.systemType}
                touched={touched.systemType}
                hideErrorText={true}
              />
            </div>

            <div>
              <CustomFilterInput
                label={t("Patient Name")}
                name="patientName"
                type="text"
                placeholder={t("Enter Patient Name")}
                value={values.patientName}
                onChange={handleChange}
                onBlur={handleBlur}
                error={errors.patientName}
                touched={touched.patientName}
                hideErrorText={true}
              />
            </div>

            <div>
              <CustomFilterInput
                label={t("National ID or Iqama")}
                name="nationalId"
                type="text"
                placeholder={t("Enter National ID or Iqama")}
                value={values.nationalId}
                onChange={handleChange}
                onBlur={handleBlur}
                error={errors.nationalId}
                touched={touched.nationalId}
                hideErrorText={true}
              />
            </div>

            <div className="flex items-end">
              <AppButton
                label={t("Request")}
                onClick={handleSubmit}
                disabled={chiLoading}
                startIcon={<PersonSearchIcon className="!text-[16px]" />}
              />
            </div>

            <AutoSubmit />
          </div>
        </div>
      )}
    </Formik>
  );
}

export default AramcoChhiForm;
